export default {
    name: 'SettingsDropdown',
    props: {
        handleCommand: {
            type: Function,
            default: () => {}
        },
        settingOptions: {
            type: Array,
            default: () => {}
        },
        settingsData: {
            type: Object,
            default: () => {}
        }
    }
}